import { render, staticRenderFns } from "./input-carteirinha.vue?vue&type=template&id=1b5a12b0"
import script from "./input-carteirinha.vue?vue&type=script&lang=ts"
export * from "./input-carteirinha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports